import React, { FC, createContext, useState } from "react";
import { RouteComponentProps } from "react-router";
import { CustomFieldTemplateApi } from "go-segment/services/types";
import { ProductApi, ProductType } from "../../../../../../../../../../services/Api/Organization/types";
import ProductEdit from "../../../../components/Tabs/ProductEdit/ProductEdit";

interface ProductContextType {
	product?: ProductApi;
	productType?: ProductType;
	setProduct: (newProduct: ProductApi) => void;
	setProductType: (type: ProductType) => void;
	customFieldsConfig?: CustomFieldTemplateApi[];
	setCustomFieldsConfig: (newCFConfig: CustomFieldTemplateApi[]) => void;
}

const ProductContext = createContext<ProductContextType>({
	product: {} as ProductApi,
	setProduct: (newProduct: ProductApi) => {},
	customFieldsConfig: [] as CustomFieldTemplateApi[],
	setCustomFieldsConfig: (newCFConfig: CustomFieldTemplateApi[]) => {},
	setProductType: (type: ProductType) => {},
});

export const OrganizationProductEditPage: FC<RouteComponentProps> = (props) => {
	const [product, setProduct] = useState<ProductApi | undefined>(undefined);
	const [customFieldsConfig, setCustomFieldsConfig] = useState<CustomFieldTemplateApi[] | undefined>(undefined);
	const [productType, setProductType] = useState<ProductType | undefined>(product?.type);

	return (
		<ProductContext.Provider
			value={{
				product,
				setProduct,
				customFieldsConfig,
				setCustomFieldsConfig,
				setProductType,
				productType,
			}}
		>
			<ProductEdit {...props} />
		</ProductContext.Provider>
	);
};

export default ProductContext;
